import { ThemeProvider } from '@emotion/react';
import { theme } from './theme/theme';
import './App.css';
import { AppRoutes } from './Routes';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import store from './modules/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { captureConsoleIntegration } from '@sentry/integrations';

const queryClient = new QueryClient();

const isProduction = process.env.NODE_ENV === 'production';
if (isProduction) {
  Sentry.init({
    dsn: 'https://0422672528d0515a31e2c448ef68792c@o4504208781606912.ingest.us.sentry.io/4506901868904448',
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // http://localhost:3000/
        tracePropagationTargets: [/^https:\/\/pella\.gale\.technology\//],
      }),
      captureConsoleIntegration({
        // array of methods that should be captured
        levels: ['log'],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <AppRoutes />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
